import type * as PaymentMethodGlyphs from '@sunwebgroup/uds-payment-method-icons'
import type { PaymentMethodIconProps } from './PaymentMethodIcon.types'
import cn from 'classnames'
import * as React from 'react'
import * as paymentIconGlyphs from '../../payment-method-glyphs'
import styles from './PaymentMethodIcon.module.css'

export type PaymentMethodIconGlyph = Extract<keyof typeof PaymentMethodGlyphs, string>

export const allPaymentMethodIconGlyphNames = Object.keys(paymentIconGlyphs)

type PaymentMethodIconCSSProperties = React.CSSProperties & {
  '--_payment-icon-size'?: string
}

export function PaymentMethodIcon({ className, glyph, size = 16, ...attrs }: PaymentMethodIconProps) {
  if (!glyph) {
    return null
  }
  const GlyphComponent = paymentIconGlyphs[glyph]

  if (GlyphComponent === undefined) {
    console.error(`Icon: No icon found for glyph "${glyph}"`)
    return null
  }

  const mergedStyles: PaymentMethodIconCSSProperties = { '--_payment-icon-size': `var(--payment-icon-size, ${size}px)` }

  return (
    <span className={cn(styles.paymentIcon, className)} style={mergedStyles}>
      <GlyphComponent {...attrs} />
    </span>
  )
}

PaymentMethodIcon.displayName = 'PaymentMethodIcon'
